import { Core } from "@/core/Core";

export default {
  
  async getVisiblePromotions(context, {inventory, branch, company}) {
    try {
      let response = company
        ? await Core.request("GET", `/api/branches/${branch}/companies/${company}/promotions-info`)
        : await Core.request("GET", `/api/inventory/${inventory}/promotions-info`);
      
      return response.visiblePromotions;
    } catch (e) {
      return null;
    }
  },
  
  async getPromotions(context, {inventory}) {
    try {
      return await Core.request("GET", `/api/inventory/${inventory}/promotions`);
    } catch (e) {
      return null;
    }
  },
  
  async getPromotion(context, {id, inventory}) {
    try {
      return await Core.request("GET", `/api/inventory/${inventory}/promotions/${id}`);
    } catch (e) {
      return new Core.Error(e);
    }
  },

  async savePromotion(context, {id, inventory, data}) {
    try {
      return await Core.request("PUT", `/api/inventory/${inventory}/promotions/${id}`, data);
    } catch (e) {
      return null;
    }
  },

  async createPromotion(context, {inventory, data}) {
    try {
      return await Core.request("POST", `/api/inventory/${inventory}/promotions`, data);
    } catch (e) {
      return null;
    }
  },

  async deletePromotion(context, {inventory, id}) {
    try {
      return await Core.request("DELETE", `/api/inventory/${inventory}/promotions/${id}`);
    } catch (e) {
      return null;
    }
  },
  
  async statsOfPromotion(context, {inventory, id, filters = {}}) {
    try {
      return await Core.request("GET", `/api/inventory/${inventory}/promotions/${id}/stats`, filters);
    } catch (e) {
      return null;
    }
  }
}